import React, { useEffect, useContext } from 'react';
import { HomeProvider } from './HomeContext';
import { NavContext, UserContext } from '../../contexts';
import { makeStyles } from '@material-ui/core/styles';
import {
    Typography,
    Container,
    Button,
    Card,
    CardContent
} from "@material-ui/core";

const useStyles = makeStyles({
    root: {
        textAlign: 'center'
    },
    activeYearButton: {
        width: 80,
        heigth: 30,
        backgroundColor: "#c2a07b",
        fontSize: 20,
        margin: 20,
        '&:hover': {
            backgroundColor: "rgb(135, 112, 86)",
        }
    },
    archiveYearButton: {
        fontSize: 15,
        backgroundColor: "rgba(200, 200, 200)",
        margin: 20,
        '&:hover': {
            backgroundColor: "rgba(200, 200, 200, 0.5)",
        }
    },
    cardBox:{
        padding:20,
        marginTop:20
    }
});

const PageContent = (props) => {
    const classes = useStyles();
    const { setBreadcrumbRoot, addBreadcrumbToken } = useContext(NavContext);
    
    useEffect(() => {
        setBreadcrumbRoot("")
    }, []);

    const {
        getBudgetSessionAsync,
        budgetYears,
        setSelectedYear
    } = useContext(UserContext);

    const selectYearClickHandler = (year) => {
        setSelectedYear(year.budgetYearId);
        getBudgetSessionAsync(year.budgetYearId, "homepage");
    }

    return (
        <div>
            {
                budgetYears ?
                <Container className={classes.root}>
                    <Typography variant='h5'>CHOSE WORKING YEAR</Typography>
                    <Card className={classes.cardBox}>
                        <Typography variant='h6'>Active years</Typography>
                        <CardContent>
                            {
                                budgetYears.items.filter(y => y.isActive === true).length > 0 
                                ?
                                budgetYears.items.filter(y => y.isActive === true).map((year, index) => {
                                    return (
                                        <Button key={index} variant='contained' onClick={() => selectYearClickHandler(year)} className={classes.activeYearButton}>{year.observedYear}</Button>
                                    )
                                })
                                :
                                <Typography>No active years</Typography>
                            }
                        </CardContent>
                    </Card>
                    <Card className={classes.cardBox}>
                        <Typography variant='h6'>Archive</Typography>
                        <CardContent>
                            {
                                budgetYears.items.filter(y => y.isActive === false).length > 0
                                ?
                                budgetYears.items.filter(y => y.isActive === false).map((year, index) => {
                                    return (
                                        <Button key={index} variant='contained' onClick={() => selectYearClickHandler(year)} className={classes.archiveYearButton}>{year.observedYear}</Button>
                                    )
                                })
                                :
                                <Typography>No archived years</Typography>
                            }
                        </CardContent>
                    </Card>
                </Container>
                :
                <Typography>No years found</Typography>}
        </div>
    );
}

export const HomePage = () => {

    return (
        <HomeProvider>
            <PageContent />
        </HomeProvider>
    );
}